module.exports = __webpack_public_path__ + "assets/img/img51.8f8ee8ee.png";